import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";

import { FeatureItem } from "./FeatureItem";
import { AiIcon } from "./icons/AiIcon";
import { HeadphonesIcon } from "./icons/HeadphonesIcon";
import { PhoneIcon } from "./icons/PhoneIcon";
import { TrendingUpIcon } from "./icons/TrendingUpIcon";

const I18N_ROOT = "pricing_plans.upgrade_modal.enterprise_plus";

export const LeftPane = () => (
  <div className="space-y-4">
    <div className="mb-2">
      <Typography.BodyMd color="text-default">
        {t(`${I18N_ROOT}.description`)}
      </Typography.BodyMd>
    </div>
    <FeatureItem
      icon={<AiIcon />}
      title={t(`${I18N_ROOT}.features.ai_agents.title`)}
      description={t(`${I18N_ROOT}.features.ai_agents.description`)}
    />
    <FeatureItem
      icon={<HeadphonesIcon />}
      title={t(`${I18N_ROOT}.features.support.title`)}
      description={t(`${I18N_ROOT}.features.support.description`)}
    />
    <FeatureItem
      icon={<TrendingUpIcon />}
      title={t(`${I18N_ROOT}.features.limits.title`)}
      description={t(`${I18N_ROOT}.features.limits.description`)}
    />
    <FeatureItem
      icon={<PhoneIcon />}
      title={t(`${I18N_ROOT}.features.branded_apps.title`)}
      description={t(`${I18N_ROOT}.features.branded_apps.description`)}
    />
  </div>
);
